import RpcClass from "../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.Formula';

import LocalDate from "../../../../server/LocalDate.js";
import LocalDateTime from "../../../../server/LocalDateTime.js";
import LocalTime from "../../../../server/LocalTime.js";



class Formula extends RpcClass{

    /**
     *  @class Formula
     *  @alias module:src/server/com/silkplm/rpc/Formula.Formula
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param formulaInput {string} 
     * @param date {LocalDate} 
     * @param transitTime {number} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<LocalDate>}
     */
     surchargeDateBalanceOrderFormula(formulaInput, date, transitTime) {
            let rawPromise;
            let p = new Promise(function (resolve, reject) {
                rawPromise = RpcClass.rpcCall('/rpc/formula/surcharge-date-balance-order-formula', [formulaInput, date, transitTime]);
                rawPromise.then(rawValue => {
                    let v = null;
                    if(rawValue == null){
                        resolve(v);
                        return;
                    }
                    v = new LocalDate(); v.value = rawValue;
                    resolve(v);
                }).catch(e => {reject(e)})
            });
            p.onProgress = function(callback){
                rawPromise.onProgress(callback);
                return p;
            }
            return p;
    }
    /** 
     * @async
     * @param formulaInput {string} 
     * @param value {LocalDate} 
     * @param key {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<LocalDate>}
     */
     surchargeDateBalanceShipmentFormula(formulaInput, value, key) {
            let rawPromise;
            let p = new Promise(function (resolve, reject) {
                rawPromise = RpcClass.rpcCall('/rpc/formula/surcharge-date-balance-shipment-formula', [formulaInput, value, key]);
                rawPromise.then(rawValue => {
                    let v = null;
                    if(rawValue == null){
                        resolve(v);
                        return;
                    }
                    v = new LocalDate(); v.value = rawValue;
                    resolve(v);
                }).catch(e => {reject(e)})
            });
            p.onProgress = function(callback){
                rawPromise.onProgress(callback);
                return p;
            }
            return p;
    }
    /** 
     * @async
     * @param formulaInput {string} 
     * @param ATD {LocalDate} 
     * @param testInt {number} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<LocalDate>}
     */
     testFormula(formulaInput, ATD, testInt) {
            let rawPromise;
            let p = new Promise(function (resolve, reject) {
                rawPromise = RpcClass.rpcCall('/rpc/formula/test-formula', [formulaInput, ATD, testInt]);
                rawPromise.then(rawValue => {
                    let v = null;
                    if(rawValue == null){
                        resolve(v);
                        return;
                    }
                    v = new LocalDate(); v.value = rawValue;
                    resolve(v);
                }).catch(e => {reject(e)})
            });
            p.onProgress = function(callback){
                rawPromise.onProgress(callback);
                return p;
            }
            return p;
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.Formula';
metadata.__type_short__ = 'Formula';
Formula.prototype.__metadata__ = metadata;

Formula.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/Formula */
export default Formula

export { Formula }
